module.exports = __webpack_public_path__ + "img/logo-back.2489b38b.png";